"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _default = {
  storyboard: !0,
  return: !0,
  template: !0,
  audio: !0,
  comments: !0,
  script: !0,
  inspiration: !0,
  remove: !0,
  document: !0,
  edit: !0
};
exports["default"] = _default;